module.exports = __webpack_public_path__ + "static/media/login-bg.74dc8d9f.svg";